// https://content.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=PLfOfV6WWO1r41Ob9op8GJv4zlvWirYKxs&key=AIzaSyD-a9IF8KKYgoC3cpgS-Al7hLQDbugrDcw

// setup the playlists id's
var playlists = {
  first: 'PLfOfV6WWO1r41Ob9op8GJv4zlvWirYKxs',
  second: 'PLfOfV6WWO1r7mk4nbrl0s9dK2fxgiXa4B',
  third: 'PLfOfV6WWO1r5TWpP0h5W2uq88JksY91dM'
};

var Videos = React.createClass({
    getInitialState: function () {
        return {
            apiRoot: 'https://content.googleapis.com/youtube/v3/',
            firstParam: 'playlistItems?maxResults=20&part=snippet',
            secondParam: '&playlistId=',
            thirdParam: '&key=AIzaSyAE3r0R3Y0mx4QYQzvHuEiTizXHsgcacwk',
            firstPlaylist: [],
            secondPlaylist: [],
            thirdPlaylist: []
        };
    },

    getApiUrl: function ( playlist ) {
        var url = this.state.apiRoot + this.state.firstParam + this.state.secondParam + playlist + this.state.thirdParam;
        return url;
    },

    getPlaylist: function () {
        var first = this.getApiUrl( playlists.first );
        var second = this.getApiUrl( playlists.second );
        var third = this.getApiUrl( playlists.third );
        var self = this;

        $.getJSON( first, function ( data ) {
            self.setState({ firstPlaylist: data.items });
        });

        $.getJSON( second, function ( data ) {
            self.setState({ secondPlaylist: data.items });
        });

        $.getJSON( third, function ( data ) {
            self.setState({ thirdPlaylist: data.items });
        });
    },

    componentDidMount: function () {
        this.getPlaylist();
    },

    getLink: function ( path ) {
        return 'https://www.youtube.com/watch?v=' + path;
    },

    getFirstPlaylist: function () {
        var self = this;
        var videos = this.state.firstPlaylist.map( function ( video ) {
            var bg = {
                backgroundImage: 'url(' + video.snippet.thumbnails.high.url + ')',
            };
            return(
                <div className="col-xs-12 col-sm-3">
                    <div className="card-video">
                        <a className="play-video" href={self.getLink(video.snippet.resourceId.videoId)}>
                            <div className="card-image" style={bg}>
                                <i className="fa fa-play-circle" aria-hidden="true"></i>
                            </div>
                        </a>
                        <div className="card-content">
                            <h4>{video.snippet.title}</h4>
                        </div>
                    </div>
                </div>
            );
        });

        return videos;
    },

    getSecondPlaylist: function () {
        var self = this;
        var videos = this.state.secondPlaylist.map( function ( video ) {
            var bg = {
                backgroundImage: 'url(' + video.snippet.thumbnails.high.url + ')',
            };
            return(
                <div className="col-xs-12 col-sm-3">
                    <div className="card-video">
                        <a className="play-video" href={self.getLink(video.snippet.resourceId.videoId)}>
                            <div className="card-image" style={bg}>
                                <i className="fa fa-play-circle" aria-hidden="true"></i>
                            </div>
                        </a>
                        <div className="card-content">
                            <h4>{video.snippet.title}</h4>
                        </div>
                    </div>
                </div>
            );
        });

        return videos;
    },

    getThirdPlaylist: function () {
        var self = this;
        var videos = this.state.thirdPlaylist.map( function ( video ) {
            var bg = {
                backgroundImage: 'url(' + video.snippet.thumbnails.high.url + ')',
            };
            return(
                <div className="col-xs-12 col-sm-3">
                    <div className="card-video">
                        <a className="play-video" href={self.getLink(video.snippet.resourceId.videoId)}>
                            <div className="card-image" style={bg}>
                                <i className="fa fa-play-circle" aria-hidden="true"></i>
                            </div>
                        </a>
                        <div className="card-content">
                            <h4>{video.snippet.title}</h4>
                        </div>
                    </div>
                </div>
            );
        });

        return videos;
    },

    render: function () {
        return(
            <section>
                <div className="container">
                    <div className="row flex">
                        {this.getSecondPlaylist()}
                    </div>
                    <div className="row flex">
                        {this.getThirdPlaylist()}
                    </div>
                    <div className="row flex">
                      {this.getFirstPlaylist()}
                    </div>
                </div>
            </section>
        );
    }
});

ReactDOM.render(<Videos/>, document.getElementById('video-app'));
